export enum ExternalUrl {
  LexikonVermoegensverzeichnis = "https://www.schuldenberatung.wien/lexikon/#Vermoegensverzeichnis",
  LexikonUnterhalt = "https://www.schuldenonline.at/vorlage?id=&edv_nr=SB+-+8399/2025&name=Unterhaltspflichten+beruecksichtigen",
  SpouseMaintenanceCheck = "https://www.schuldenonline.at/helferlein/upflpartner",
}
